<script>
  import { clearAuth, loginRedirect } from '../lib/auth.js';
  let { user } = $props();

  function signOut() { clearAuth(); loginRedirect(); }
</script>

<div class="min-h-screen flex items-center justify-center bg-surface px-4">
  <div class="max-w-md w-full bg-surface-container rounded-3xl p-8 text-center">
    <span class="material-symbols-outlined text-5xl text-on-surface-variant mb-2">lock_person</span>
    <h1 class="text-2xl font-medium mb-2">Access required</h1>
    <p class="text-on-surface-variant mb-6">
      You're signed in as
      <span class="text-on-surface font-medium">{user?.email || user?.username || 'unknown user'}</span>,
      but your account hasn't been granted access to hook-index yet.
    </p>
    <p class="text-sm text-on-surface-variant mb-6">
      Ask an existing hook-index user to grant you access from the Users tab.
    </p>
    <p class="text-sm text-on-surface-variant mb-8">
      For account or profile changes visit
      <a href="https://account.telebroad.com" class="text-primary hover:underline">account.telebroad.com</a>.
    </p>
    <button
      onclick={signOut}
      class="px-6 py-2.5 rounded-full text-sm font-medium bg-primary text-on-primary hover:opacity-90"
    >
      Sign out
    </button>
  </div>
</div>
